module.exports = "/_next/static/images/headphones-duotone-510c97bbc3b04a89038f751148a16577.svg";